export default __webpack_public_path__ + "static/char-s-02-jp-4bfce64c88890271486a9b491794a234.webp";